import { createReducer, on } from '@ngrx/store';
import { userManagementActions } from '../actions/user-management.actions';

export interface UserManagementState {
    saved: boolean | null;
    saving: boolean;
}

export const initialState: UserManagementState = {
    saved: null,
    saving: false,
};

export const userManagementReducer = createReducer(
    initialState,
    on(userManagementActions.editUser, (state): UserManagementState => ({ ...state, saved: null, saving: true })),
    on(userManagementActions.editUserSuccess, (state): UserManagementState => ({ ...state, saved: true, saving: false })),
    on(userManagementActions.editUserError, (state): UserManagementState => ({ ...state, saved: false, saving: false })),

    on(userManagementActions.clearSaved, (state): UserManagementState => ({ ...state, saved: null })),

    on(userManagementActions.clear, (): UserManagementState => ({ ...initialState })),
);
